<template>
  <vue-recaptcha
    ref="recaptcha"
    sitekey="6LcswrIUAAAAAInxRU-HMX47FyIQ-KIkXWUczmDN"
    :loadRecaptchaScript="true"
    @verify="verify"
    @expired="expired"
  >
    <button
      class="vi-button"
      :type="type"
      :class="{sm: this.size === 'sm'}"
      :disabled="disabled">
      {{label}}
    </button>
  </vue-recaptcha>

</template>

<script>
  import VueRecaptcha from 'vue-recaptcha';

  export default {
    name: 'ViRecaptchaButton',
    components: {VueRecaptcha},
    props: {
      label: {
        type: String,
        required: true
      },
      size: {
        type: String,
      },
      type: {
        type: String,
        default: 'submit'
      },
      disabled: {
        type: Boolean
      }
    },
    methods: {
      verify(e) {
        this.$emit('verify', e)
      },
      expired() {
        this.$refs.recaptcha.reset()
      }
    }
  }
</script>

<style lang="scss">
  @import "../../styles/vars";

  .vi-button {
    padding: 6px 30px;
    /*border-radius: 4px;*/
    /*box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.1);*/
    border: none;
    font-size: 14px;
    color: #ffffff;
    background: $clBrand;
    cursor: pointer;
    border-radius: 20px;
    outline: none;

    &:disabled {
      background: darken($clBrand, 10);
      content: normal;
    }

    &.sm {
      padding: 7px 10px;
      font-size: 1rem;
    }
  }
</style>
